import type {
  CandidateExperienceApi,
  CandidateTouchpointApi,
} from '@/modules/candidate-detail/queries/types';
import { experienceMonths } from '@/pages/hm/job-candidates/candidateFacts';
import { formatMonthDuration, formatRelativeDay } from '@/utils/dateUtils';

/** Overlapping roles count once: two jobs held at the same time are not double the years. */
export function getTotalExperience(
  experience: CandidateExperienceApi[],
): string | null {
  const months = experienceMonths(experience);
  return months === undefined ? null : formatMonthDuration(months);
}

/** "2 days ago": when the candidate was introduced, from the Submitted transition. */
export function getIntroducedLabel(
  touchpoints: CandidateTouchpointApi[],
): string | null {
  const introduced =
    touchpoints.find((touchpoint) => touchpoint.toStatus === 'Submitted') ??
    touchpoints.reduce<CandidateTouchpointApi | undefined>(
      (earliest, touchpoint) =>
        !earliest || touchpoint.occurredAt < earliest.occurredAt
          ? touchpoint
          : earliest,
      undefined,
    );

  return introduced ? formatRelativeDay(introduced.occurredAt) : null;
}
